import React from 'react';
import { useForm } from 'react-hook-form';
import { Controls, validators } from 'shared/helper/form';
import AsyncFormSubmission from './AsyncFormSubmission';
var Form = Controls.Form,
  Text = Controls.Text,
  Password = Controls.Password;
var isEmail = validators.isEmail,
  notEmpty = validators.notEmpty;
var defaultValues = {
  email: '',
  password: ''
};
var LoginForm = function LoginForm(_ref) {
  var loginUser = _ref.loginUser,
    _ref$onUserLoginAttem = _ref.onUserLoginAttempt,
    onUserLoginAttempt = _ref$onUserLoginAttem === void 0 ? function () {} : _ref$onUserLoginAttem,
    processing = _ref.processing;
  var methods = useForm({
    defaultValues: defaultValues,
    shouldFocusError: false
  });
  var handleLoginUser = function handleLoginUser(user) {
    return loginUser(user).then(onUserLoginAttempt);
  };
  return /*#__PURE__*/React.createElement(Form, {
    methods: methods,
    className: "login-form clearfix",
    onSubmit: handleLoginUser,
    testAttribute: "login-form"
  }, /*#__PURE__*/React.createElement(Text, {
    label: "Email address",
    messages: {
      isEmail: 'emailAddressInvalidFormat'
    },
    name: "email",
    validators: {
      isEmail: isEmail
    },
    styles: {
      wrapper: 'mb-3'
    }
  }), /*#__PURE__*/React.createElement(Password, {
    label: "Password",
    messages: {
      notEmpty: 'Please enter your password.'
    },
    name: "password",
    validators: {
      notEmpty: notEmpty
    },
    styles: {
      wrapper: 'mb-3'
    }
  }), /*#__PURE__*/React.createElement(AsyncFormSubmission, {
    processing: processing,
    label: "Login",
    testAttribute: "login-submit"
  }));
};
export default LoginForm;